// NOTE: these util functions is used for only UI V2
import _get from 'lodash/get';
import Storage from 'grab-storage';

import {
  STORAGE_CITY_V2,
  STORAGE_PICKUP_POIS,
  STORAGE_SENDER,
  STORAGE_META_DATA_VERSION,
  STORAGE_BUR_GROUPING_DEFAULT_ON,
  STORAGE_BUR_GROUPING_NOT_SHOW_POPUP,
} from '../constants/storage';

export const getCityStorage = () => {
  let result = {};
  try {
    result = JSON.parse(Storage.getItem(STORAGE_CITY_V2)) || {};
  } catch (e) {
    // do nothing
  }

  return result;
};

export const saveCityStorage = cityToStorage =>
  Storage.setItem(STORAGE_CITY_V2, JSON.stringify(cityToStorage));

export const getSenderStorage = (cityID, safeID) => {
  let result = {};
  try {
    const storageSenders = JSON.parse(Storage.getItem(STORAGE_SENDER)) || {};

    if (!cityID || !safeID) return storageSenders;

    result = _get(storageSenders, `${cityID}-${safeID}`, {});
  } catch (e) {
    return result;
  }

  return result;
};

export const setSenderStorage = (cityID, safeID, senderStorage) => {
  Storage.setItem(
    STORAGE_SENDER,
    JSON.stringify({
      ...getSenderStorage(),
      [`${cityID}-${safeID}`]: senderStorage,
    }),
  );
};

const getPickUpPOIs = () => {
  try {
    return JSON.parse(Storage.getItem(STORAGE_PICKUP_POIS));
  } catch (e) {
    return {};
  }
};

export const getPickUpPOIForUser = (cityID, safeID) => {
  const POIs = getPickUpPOIs();
  return _get(POIs, `${cityID}-${safeID}`);
};

export const savePickUpPOIInStorage = (cityID, safeID, pickUpPOI) => {
  Storage.setItem(
    STORAGE_PICKUP_POIS,
    JSON.stringify({
      ...getPickUpPOIs(),
      [`${cityID}-${safeID}`]: pickUpPOI,
    }),
  );
};

export const getNumberFromStorage = key => {
  try {
    const val = Storage.getItem(key);
    if (!val) {
      return 0;
    }

    const num = +val;
    if (isNaN(num)) {
      return 0;
    }
    return num;
  } catch (e) {
    return 0;
  }
};

export const getCurrentMetaDataVersion = () =>
  Storage.getItem(STORAGE_META_DATA_VERSION);

export const setMetaDataVersion = metaDataVersion => {
  Storage.setItem(STORAGE_META_DATA_VERSION, metaDataVersion);
};

export const getBURGroupingDefaultOn = () =>
  Storage.getItem(STORAGE_BUR_GROUPING_DEFAULT_ON);

export const setBURGroupingDefaultOn = value => {
  Storage.setItem(STORAGE_BUR_GROUPING_DEFAULT_ON, value);
};

export const getBURGroupingNotShowModal = () =>
  !!Storage.getItem(STORAGE_BUR_GROUPING_NOT_SHOW_POPUP);

export const setBURGroupingNotShowModal = value => {
  Storage.setItem(STORAGE_BUR_GROUPING_NOT_SHOW_POPUP, value);
};

export default {};
